import React, { useEffect, useReducer, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import { zoneChartService } from "../../utils/services/zoneChartService";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Button, Grid, Typography } from "@mui/material";
import CustomPagination from "../../components/pagination";
import ZoneChartList from "../../components/zone-chart-list";
import ZoneChartModal from "../../components/zone-chart-modal";
import { zoneChartOriginFilterInitialState } from "../../utils/filter-config";
import buildQuery from "../../utils/query-builder";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import { useTheme } from "@emotion/react";
import { RefreshOutlined } from "@mui/icons-material";
import { formatDate } from "../../utils/formatDate";
function filterReducer(state, action) {
  console.log(action.type);
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        columns: state?.columns.map((x) =>
          x?.key === action?.payload?.key ? { ...x, ...action.payload } : x,
        ),
      };
    case "SET_OPTIONS":
      return {
        ...state,
        columns: state.columns.map((col) =>
          col.key === action.payload.key
            ? { ...col, options: action.payload.options }
            : col,
        ),
      };
    case "UPDATE_LIMIT":
      return { ...state, limit: action.payload };

    default:
      return state;
  }
}
export default function ZoneChart() {
  const [zoneChartData, setZoneChartData] = useState([]);
  const [selectedZoneChart, setSelectedZoneChart] = useState(null);
  const [filterData, dispatch] = useReducer(
    filterReducer,
    zoneChartOriginFilterInitialState,
  );
  const [zoneConfig, setZoneConfig] = useState({});
  const clientId = localStorage.getItem("client_id");
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme.palette?.primary?.main || defaultColor;
  const [page, setPage] = React.useState(0);
  const [dataCount, setDataCount] = useState(filterData.limit);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState({ name: "" });
  const [clientFilter, setClientFilter] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [viewMode, setViewMode] = useState("list");

  const fetchZoneChartData = async () => {
    setLoading(true);
    try {
      const response = await zoneChartService.fetch(
        clientId ? clientId : clientFilter?._id,
        searchValue,
        buildQuery(filterData, page),
      );
      setZoneChartData(response.data);
      setDataCount(response?.total);
    } catch (error) {
      console.error("Fetch failed:", error);
      // Handle fetch failure
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchZoneChartConfig();
  }, []);

  const fetchZoneChartConfig = async () => {
    try {
      let resp = await zoneChartService.fetchConfig();
      setZoneConfig(resp.data[0]);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchZoneChartData();
  }, [page, clientFilter, searchValue, filterData]);

  const NoDataImage = () => (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <img
        src="no_data_zone.png"
        alt="No data available"
        style={{ objectFit: "cover", height: "340px" }}
      />
    </div>
  );

  const syncZoneChart = async () => {
    try {
      let zone_chart_config = await zoneChartService.syncZoneChart();
      setZoneConfig(zone_chart_config);
    } catch (e) {
      console.error(e);
    }
  };

  const handleFilterChange = (newFilter) => {
    console.log(newFilter);
    dispatch({ type: "SET_FILTER", payload: newFilter });
    setPage(0);
  };
  return (
    <DashboardContainer
      hideAddButton
      hideGridList
      onChangeFilter={handleFilterChange}
      searchBarPlaceholder={"Search by Zone Name"}
      onSearchData={(p) => {
        setSearchValue(p);
        setPage(0);
      }}
      onClickAddButton={() => {
        setOpenModal(true);
      }}
      hideUploadButton={true}
      header={"Zone Chart"}
      onSelectClient={(e) => {
        setClientFilter(e);
      }}
      selectedClient={selectedClient?.name}
      setViewMode={setViewMode}
      hideFilterClient
      headerButtons={
        <Grid style={{ display: "flex", flexDirection: "row" }}>
          <Button
            size="small"
            style={{
              textTransform: "none",
              marginRight: 10,
              height: 35,
            }}
            variant="contained"
            color="primary"
            onClick={() => fetchZoneChartData()}
          >
            <RefreshOutlined fill={primary_color} />
          </Button>
          <Box>
            <Button
              size="small"
              style={{
                textTransform: "none",
                // height: 40,
                width: 120,
              }}
              variant="contained"
              color="primary"
              onClick={() => syncZoneChart()}
            >
              <SyncAltIcon fill={primary_color} />
              <Typography
                fontSize="14px"
                fontWeight={500}
                sx={{
                  marginLeft: 1,
                }}
                fontFamily={"poppins"}
              >
                Sync
              </Typography>
            </Button>
            <Typography
              fontSize="10px"
              sx={{
                marginTop: 1,
              }}
              fontFamily={"poppins"}
            >
              {`Last Synced: ${
                zoneConfig
                  ? formatDate(zoneConfig.last_synced)
                  : ""
              }`}
            </Typography>
          </Box>
        </Grid>
      }
    >
      <ZoneChartModal
        selectedZoneChart={selectedZoneChart}
        handleClose={() => {
          setOpenModal(false);
          setSelectedZoneChart(null);
        }}
        open={openModal}
        onAddData={fetchZoneChartData}
      />
      {loading && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      )}

      <ZoneChartList
        onChangeFilter={handleFilterChange}
        onDeleteData={() => fetchZoneChartData()}
        onEditData={(e) => {
          console.log(e);
          setSelectedZoneChart(e);
          setOpenModal(true);
        }}
        data={zoneChartData}
        viewMode={viewMode}
        deleteTitle={"Delete Zone"}
        selectedZoneChart={selectedZoneChart}
        setSelectedZoneChart={setSelectedZoneChart}
        currentPage={page}
        itemsPerPage={filterData.limit}
        filterData={filterData}
      />

      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={filterData.limit}
        page={page}
        setPage={setPage}
        setRowsPerPage={(e) =>
          dispatch({
            type: "UPDATE_LIMIT",
            payload: e,
          })
        }
        disableNext={dataCount <= (page + 1) * filterData.limit}
      />
    </DashboardContainer>
  );
}
